/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 09/11/21
 */

import { ArrayControlProps, Paths } from '@jsonforms/core';
import merge from 'lodash/merge';
import React from 'react';
import range from 'lodash/range';
import { getValidColumnProps } from './utils';
import ChakraTableRow from './ChakraTableRow';
import ChakraEmptyTable from './ChakraEmptyTable';
import { withJsonFormsRowCount } from '../../utils/withJsonFormsRowCount';
import { namedMemo } from '@/utils/namedMemo';
interface ChakraTableRowsProps extends Omit<ArrayControlProps, 'data'> {
    count: number;
}

const ChakraTableRows = namedMemo(
    'ChakraTableRows',
    ({
        count,
        path,
        schema,
        uischema,
        config,
        enabled,
        cells,
        moveUp,
        moveDown,
        removeItems,
        label,
    }: ChakraTableRowsProps) => {
        const isEmptyTable = count === 0;

        if (isEmptyTable) {
            return <ChakraEmptyTable tableName={label} numColumns={getValidColumnProps(schema).length + 1} />;
        }

        const appliedUiSchemaOptions = merge({}, config, uischema.options);

        return (
            <>
                {range(count).map((index: number) => {
                    const childPath = Paths.compose(path, `${index}`);

                    return (
                        <ChakraTableRow
                            key={childPath}
                            childPath={childPath}
                            rowIndex={index}
                            schema={schema}
                            enableUp={index !== 0}
                            enableDown={index !== count - 1}
                            showSortButtons={appliedUiSchemaOptions.showSortButtons}
                            enabled={enabled}
                            cells={cells}
                            moveUp={moveUp && moveUp(path, index)}
                            moveDown={moveDown && moveDown(path, index)}
                            removeItem={removeItems && removeItems(path, [index])}
                        />
                    );
                })}
            </>
        );
    },
);

export default withJsonFormsRowCount(ChakraTableRows);
